import { statusUser, v2UserStatus, v4UserStatus, requestMagicLinkUser } from '@goldcast/api/backend';

export async function getUserStatus(payload, usePentestFlow = false) {
  if (usePentestFlow) {
    if (payload.isUserLoggedIn) {
      return await v4UserStatus({ body: payload });
    } else {
      return await requestMagicLinkUser({ body: payload });
    }
  } else {
    if (payload.isUserLoggedIn) {
      return await v2UserStatus({ body: payload });
    } else {
      return await statusUser({ body: payload });
    }
  }
}
